<div [formGroup]="form" (keydown.enter)="onSubmit ()">
  <div class="mb-3 mb-2 input-group">
    <div class="form-floating">
        <input [type]="inputType()" #pw formControlName="passphrase" id="decrypt" class="form-control " />
        <label for="decrypt" >{{ prompt }} <strong>{{ name () }}</strong></label>
    </div>
    <button (click)="toggleInputType()" class='btn btn-link border'><fa-icon icon="eye" ></fa-icon></button>
  </div>
  <footer-submit-cancel #foot (submit)="onSubmit ()"  (cancel)="onCancel ()"></footer-submit-cancel>
</div>